/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Action_Complete_Case_DataInputs */

const en_case_action_complete_case_data = /** @type {(inputs: Case_Action_Complete_Case_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete Case Data`)
};

const pt_br2_case_action_complete_case_data = /** @type {(inputs: Case_Action_Complete_Case_DataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completar dados do caso`)
};

/**
* | output |
* | --- |
* | "Complete Case Data" |
*
* @param {Case_Action_Complete_Case_DataInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_action_complete_case_data = /** @type {((inputs?: Case_Action_Complete_Case_DataInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Action_Complete_Case_DataInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_action_complete_case_data(inputs)
	return pt_br2_case_action_complete_case_data(inputs)
});